import { render, staticRenderFns } from "./runRecord.vue?vue&type=template&id=f6d3861c&scoped=true&"
import script from "./runRecord.vue?vue&type=script&lang=js&"
export * from "./runRecord.vue?vue&type=script&lang=js&"
import style0 from "./runRecord.vue?vue&type=style&index=0&id=f6d3861c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d3861c",
  null
  
)

export default component.exports